"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.rule)({
    h: '1px',
    ov: 'hidden',
});
const Separator = ({ invisible, hard, style }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("div", { className: blockClass, style: {
            ...(style || {}),
            background: invisible ? undefined : styles.g(0, (hard ? 2 : 1) * 0.08),
        } }));
};
exports.Separator = Separator;
